export enum UserRole {
  ADMIN = 'admin',
  SUPPORT = 'support',
  AMC = 'amc-user',
  AMC_ADMIN = 'amc-admin',
  AMC_SUPPORT = 'amc-support',
}

export interface AmcAccess {
  amcId: string;
  role: UserRole | string;
}

export interface CreateUserData {
  name: string;
  email: string;
  password: string;
  role: UserRole | string;
  isActive?: boolean;
  amcId?: string;
  /** RTA AMC ids to hide from this user. Optional + backward compatible. */
  excludedRtas?: string[];
}

export interface User extends CreateUserData {
  id: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
  lastLoggedIn?: string;
  amcIds?: string[];
  amcAccess?: AmcAccess[];
  amc?: {
    id: string;
    name: string;
    logoPath: string;
  };
}

export interface UpdateUserData {
  name?: string;
  email?: string;
  role?: UserRole | string;
  isActive?: boolean;
  password?: string;
  amcId?: string;
  amcAccess?: AmcAccess[];
  /** RTA AMC ids to hide. Send [] to clear all exclusions. Optional. */
  excludedRtas?: string[];
}
